import {
  Form,
  InputNumber,
  Modal,
  ModalProps,
  FormProps,
} from "@pankod/refine-antd";

type Props = {
  formProps: FormProps;
  modalProps: ModalProps;
};

export const AkgPriceRangeEdit: React.FC<Props> = ({
  formProps,
  modalProps,
}) => {
  return (
    <Modal {...modalProps} title="Fiyat Aralığını Düzenle" width={500}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Min Fiyat (₺)"
          name="min"
          rules={[
            { required: true, message: "Min fiyat boş olamaz." },
          ]}
        >
          <InputNumber style={{ width: "100%" }} min={0} precision={2} />
        </Form.Item>
        <Form.Item
          label="Max Fiyat (₺)"
          name="max"
          tooltip="Boş bırakılırsa sınırsız kabul edilir."
        >
          <InputNumber style={{ width: "100%" }} min={0} precision={2} />
        </Form.Item>
        <Form.Item
          label="AKG Fiyatı (₺)"
          name="akg"
          rules={[
            { required: true, message: "AKG fiyatı boş olamaz." },
          ]}
        >
          <InputNumber style={{ width: "100%" }} min={0} precision={2} />
        </Form.Item>
        <Form.Item
          label="AKG Plus Fiyatı (₺)"
          name="akgPlus"
          rules={[
            { required: true, message: "AKG Plus fiyatı boş olamaz." },
          ]}
        >
          <InputNumber style={{ width: "100%" }} min={0} precision={2} />
        </Form.Item>
        <Form.Item label="Sıra" name="sortOrder">
          <InputNumber style={{ width: "100%" }} min={0} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
